module.exports = __webpack_public_path__ + "img/banner_lyra.a25ff7ae.png";